import { memo } from 'react';
import { Col, Button } from 'antd';
import classNames from 'classnames';
import { useCreditManagement } from '@/hooks';
import { IoAlertCircleOutline } from 'react-icons/io5';
import { useTranslation } from 'react-i18next';

export const CreditIncrement = memo(() => {
  const [t] = useTranslation(['common']);
  const { tokenLoading, getLoginToken } = useCreditManagement();

  return (
    <div className="text-start flex flex-col p-4 pb-4 mt-3 center bg-color-wf2 rounded-2xl">
      <div className="text-base font-bold w-full my-2 mb-3">
        {t('common:labels.charge-credit')}
      </div>
      <div className="flex-center w-full">
        <IoAlertCircleOutline size="2.5rem" color="#43bf58" />
        <div className="color-4d text-sm px-3 w-80">
          {t('common:messages.payment-info')}
        </div>
        <Col span={6}>
          <Button
            size="large"
            type="default"
            style={{ background: 'linear-gradient(to bottom right, #70db6f, #48b25a)' }}
            className={classNames(
              'items-center justify-center font-medium !text-white',
              'btn flex-fill rounded-xl w-full flex border-none'
            )}
            loading={tokenLoading}
            onClick={getLoginToken}
          >
            {t('common:labels.pay')}
          </Button>
        </Col>
      </div>
    </div>
  );
});

export default CreditIncrement;
